import { render, staticRenderFns } from "./MiddleYouCanHostUpTo.vue?vue&type=template&id=4978c680&scoped=true&"
import script from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js&"
export * from "./MiddleYouCanHostUpTo.vue?vue&type=script&lang=js&"
import style0 from "./MiddleYouCanHostUpTo.vue?vue&type=style&index=0&id=4978c680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978c680",
  null
  
)

export default component.exports